// Charge la base commune
import './common.js'

// Contact Form
async function getJForm($f) {
  import(/* webpackChunkName: "contactForm" */ './js/components/jobForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Location Form
async function getLForm($f) {
  $f.load()
  import(/* webpackChunkName: "locationForm" */ './js/components/locationForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// gestion des job box items
const $jbi = $('.jb-wrapper')
if ($jbi.length) {
  $jbi.waypoint(
    function () {
      import(/* webpackChunkName: "jobBoxItem" */ './scss/components/jobBoxItem.scss').then(() => {
        Waypoint.refreshAll()
      })
      this.destroy()
    },
    {
      offset: '100%',
    }
  )
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // alertes bootstrap
  const $a = $('.alert')
  if ($a.length) {
    $a.waypoint(
      function () {
        import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss')
        this.destroy()
      },
      {
        offset: '100%',
      }
    )
  }

  // formulaire de contact
  const $c = $('form[name="jForm"]')
  $c.waypoint(
    function () {
      $c.load()
      getJForm($c)
      this.destroy()
    },
    {
      offset: '100%',
    }
  )

  // gestion de la localisation
  const $c2 = $('form[name="lForm"]')
  if ($c2.length) {
    $c2.waypoint(
      function () {
        getLForm($c2)
        this.destroy()
      },
      {
        offset: '100%',
      }
    )
  }

  // gestion des filtres de navigation
  const $c3 = $('.filter-nav')
  if ($c3.length) {
    $c3.waypoint(
      function () {
        import(/* webpackChunkName: "filterNav" */ './scss/components/filterNav.scss').then(() => {
          Waypoint.refreshAll()
        })
        this.destroy()
      },
      {
        offset: '100%',
      }
    )
  }

  if ($('.go').length) {
    const target = $('.go')
    $('html').animate(
      { scrollTop: $(target).offset().top - $('#header').height() - 20 },
      { duration: 300, easing: 'linear' },
      function () {
        $('html').animate(
          { scrollTop: $(target).offset().top - $('#header').height() - 20 },
          { duration: 300, easing: 'linear' }
        )
      }
    )
  }
})
